import http from "./Http";

/**
 * Valida texto (profanidad y +18) en backend.
 * @param {{tema: string, objetivo?: string, sub_area_tematica: string}} datos
 * @returns {Promise<{ok: boolean}>}
 */
const validarContenido = (datos) => {
  return http.post("/moderacion/validar", datos);
};

const ModeracionService = {
  validarContenido,
};

export default ModeracionService;
